const Loader = () => (
  <div className="container">
    <div className="loading">Loading...</div>
  </div>
);
export default Loader;
